import { FC } from 'react'
import checkDoubleLineIcon from 'src/assets/svg/check-double-line.svg'
import checkLineIcon from 'src/assets/svg/check-line.svg'
import classes from './adCategoryDropdown.module.scss'

const AD_CATEGORIES = [
  'All ads',
  'Issues, elections or politics',
  'Housing',
  'Employment',
  'Credit',
  'Social issues',
]

interface AdCategoryDropdownProps {
  onClose: () => void
  onSelect: (category: string | null) => void
  selected: string | null
}

export const AdCategoryDropdown: FC<AdCategoryDropdownProps> = ({
  onClose,
  onSelect,
  selected,
}) => {
  const handleSelect = (category: string) => {
    if (category === 'All ads') {
      onSelect(selected === 'All ads' ? null : 'All ads')
    } else {
      onSelect(selected === category ? null : category)
    }
  }

  const isSelected = (category: string) => {
    if (selected === 'All ads') return true
    return selected === category
  }

  return (
    <div className={classes.dropdown}>
      <div className={classes.header}>
        <span className={classes.title}>Select Ad Category</span>
        <button className={classes.closeBtn} onClick={onClose} type="button">
          <svg
            fill="none"
            height="16"
            viewBox="0 0 16 16"
            width="16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 4L4 12M4 4L12 12"
              stroke="#25262D"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
          </svg>
        </button>
      </div>

      <div className={classes.list}>
        {AD_CATEGORIES.map((category) => {
          const isAllAds = category === 'All ads'
          const selected_ = isSelected(category)
          const icon = isAllAds ? checkDoubleLineIcon : checkLineIcon
          return (
            <div
              className={`${classes.item} ${isAllAds ? classes.itemAllAds : ''}`}
              key={category}
              onClick={() => handleSelect(category)}
            >
              <div
                className={`${classes.radio} ${selected_ ? classes.radioSelected : ''}`}
              >
                {selected_ && (
                  <img alt="check" className={classes.radioCheck} src={icon} />
                )}
              </div>
              <span className={classes.itemName}>{category}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
